import React from "react"

import PageHeader from "components/PageHeader";
import ApartmentListings from "components/Apartment/ApartmentListings";
import Section from "components/Section";
import Img from "components/Img";
import routes from "configs/routes";
import Button from "components/Button";
import Faq from "components/Faq";

import apartment_image_3 from 'assets/images/csango10-13kerulet-elado-lakasok.webp';

const Apartments = () => {
    return (
        <>
            <PageHeader/>

            <Section title="LAKÁSOK" description={"Eladó lakásaink Budapest egyik legfrekventáltabb helyén, a dinamikusan fejlődő 13. kerületben találhatóak. Legyen akár az első otthonod, vagy kinőtted a korábbit és nagyobb lakást keresel, ez az ideális választás."}>
                <ApartmentListings viewType="row"/>
            </Section>

            <Section additionalClasses="pt-0">
                <div className="row justify-content-between">

                <div className="col-lg-4 col-12 text-part shift-content-right order-md-2 order-lg-1">
                        <div className="text-part-content">
                            <div className="title">Az otthonod téged tükröz!</div>
                            <div className="capital">Eladó lakásaink Budapest dinamikusan fejlődő 13. kerületében találhatóak.</div>
                            <div className="text">A jövőbeni lakástulajdonosok több lakástípus közül válogathatnak:
                            <ul>
                            <li>egyszobás, 30 m<sup>2</sup>-es stúdiólakás,</li>
                            <li>40-50 m<sup>2</sup>-es egy hálószobával kiegészített nappalis, <b>modern</b> lakás,</li>
                            <li>2 hálószobás, 80 m<sup>2</sup>-es <b>családi</b> otthon.</li>
                            </ul>
                            </div>
                            <div className="text">A földszinti lakások saját használatú, <b>privát kerttel</b> rendelkeznek, az emeleteken található lakások túlnyomó többségének <b>erkélye van</b>.</div>
                            <div className="text">Lakásaink a megfelelő elosztásnak, tájolásnak és méretezésnek köszönhetően, <b>minden generáció igényeit kielégítik.</b></div>
                            <div className="text">A társasház, valamint környezete is <b>állatbarát</b>, így nem kell aggódnod, hogy kedvenced nem fogja szeretni új otthonát.</div>
                            <div className="text">Fontos számunkra a kiemelkedő minőség, emiatt eladó lakásainkban csak <b>prémium</b> minőségű anyagokat használunk.</div>
                        </div>
                    </div>
                    
                    <div className="col-lg-8 col-12 dots dots-bottom-right shifted-text-part-img-container order-md-1 order-lg-2">
                        <Img src={ apartment_image_3 } className="img-fluid" skeletonprops={ { height: 295 } }/>
                    </div>

                </div>
            </Section>

            <Faq sectionAdditionalClasses="pt-0"
            data={[
                {
                    title : "A burkolatokat én választom ki?",
                    description : <div>
                        <span className="mb-1">Igen.</span>
                        <ul>
                            <li>Duravit D-CODE szaniterek</li>
                            <li>GROHE csaptelepek</li>
                            <li>Olasz I. osztályú hidegburkolatok/kerámiák</li>
                            <li>Jaffholz ajtók 6 féle színben</li>
                        </ul>
                        <span className="mt-1">Részletekért keresd értékesítőinket.</span>
                    </div>,
                },
                {
                    title : "Hozhatok saját burkolatokat is?",
                    description : "Nem, kivitelezőink a meghatározott termékekkel dolgoznak."
                },
                {
                    title : "A konyhabútor benne van a vételárban?",
                    description : "Nem, a vételár nem foglalja magába a konyhabútort."
                }
            ]}
            />

        </>
    )
}

export default Apartments;